import { Snackbar, Alert, Box } from "@mui/material";
import { snackBar } from "src/content/keywordResearch/keywordOverview/keywordOverviewCSS";

interface OrbitAISnackbarProps {
  open: boolean;
  onClose: () => void;
  status: string | null | undefined;
  message: string | null | undefined;
  autoHideDuration?: number;
}

export default function OrbitAISnackbar({
  open,
  onClose,
  status,
  message,
  autoHideDuration = 4000
}: OrbitAISnackbarProps) {
  if (!status || !open) return null;

  return (
    <Snackbar
      sx={{ marginTop: '2.8rem' }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <Box>
        <Alert
          onClose={onClose}
          severity={(status === 'success' ? 'success' : 'error') as any}
          variant="filled"
          sx={{
            ...(status === 'success' ? snackBar?.alert : snackBar?.alertError),
            backgroundColor:
              status === 'success'
                ? 'var(--color-success-bg-ultra)'
                : 'var(--color-error-bg)',
            border:
              status === 'success'
                ? '1px solid var(--color-success-border)'
                : '1px solid var(--color-error-red)',
            maxWidth: '667px'
          }}
        >
          {message}
        </Alert>
      </Box>
    </Snackbar>
  );
}
